import { AwsCognitoIdentity } from './AwsCognitoIdentity';
import CognitoConfigStore from '../config/cognitoConfigStore';
import { AzureIdentity } from './AzureIdentity';
import AzureConfigStore from '../config/azureConfigStore';

class IdentityManagerFactory {
  manager: any;

  constructor() {}

  getManager() {
    return this.manager;
  }

  init(data: any) {
    if (data.useCognito) {
      this.manager = new AwsCognitoIdentity(new CognitoConfigStore(data.cognitoConfig));
      return Promise.resolve();
    }

    let azureIdentity = new AzureIdentity(new AzureConfigStore(data.azureConfig));
    this.manager = azureIdentity;
    return azureIdentity.initialize();
    // this.manager = data.useCognito
    //   ? new AwsCognitoIdentity(new CognitoConfigStore(data.cognitoConfig))
    //   : new AzureIdentity(new AzureConfigStore(data.azureConfig));
  }
}

let IdentityManager = new IdentityManagerFactory();

export default IdentityManager;
